<template>
  <!-- 资料 -->
  <div class="salesman-form-material">
    <Upload
      v-if="$units.pointAction('org_1_4')"
      :show-upload-list="false"
      :multiple="false"
      action="/"
      :before-upload="handleUpload"
      style="float:left"
    >
      <span class="upload-info">仅支持上传pdf、excel、word、ppt格式文件</span>
      <Button class="save-btn border" ghost type="primary">上传</Button>
    </Upload>
    <div class="table-box" >
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" v-if="tableData.length">
        <template slot-scope="{ row }" slot="name">
          <div class="file-name">
            <span class="dian" :class="{'red':row.isUsed!=1}"></span>
            <span class="name" @click="download(row)">{{row.name}}</span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" v-if="row.isUsed==1" @click="checkFile(row)" >失效</span>
          <span class="table-btn" v-else @click="checkFile(row)" >有效</span>
          <span class="table-btn line" @click="del(row)" >删除</span>
        </template>
      </Table>
      <no-data v-else></no-data>
    </div>
  </div>
</template>

<script>
import {pageTool} from "@/api/mixins";
import { uploadFile } from "@/api/httpList";
export default {
  mixins:[pageTool],
  components: {},
  props: {
    formData:null,
    curTreeData:null,
  },
  data() {
    return {
      tableData:[],
      columns:[
        {
          title: "序号",
          type: 'index',
          width: 80,
          align: 'center'
        },
        {
          title: "文件名称",
          slot: "name",
          minWidth: 150,
          align: "center",
        },
        {
          title: "上传用户",
          key: "createBy",
          width: "150",
          align: "center"
        },
        {
          title: "上传时间",
          key: "createTime",
          width: "150",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "160",
        },
      ]
    };
  },
  watch: {
  },
  computed: {},
  created() {},
  mounted() {
    
  },
  methods: {
    setData(data){
      this.getFormData(data.id)
    },
    // 获取列表数据
    getFormData(id){
      this.listLoading = true;
      this.$http({
        type: "GET",
        url: "/buz/organizationFile/getByOrgId",
        data: {
          orgId:id
        }
      }).then(res => {
        this.tableData = res.data.map(item=>{
          if(item.createTime){
            item.createTime = item.createTime.substr(0,10)
          }
          return item;
        });
      }).finally(e=>{
        this.listLoading = false;
      })
    },
    handleUpload(file) {
      const reg = /\.(pdf|xlsx|xls|doc|docx|ppt|pptx|)$/;
      const txt = "pdf、excel、word、ppt";
      if (!reg.test(file.name.toLowerCase())) {
        this.$Message.error(`上传格式不正确，请上传${txt}格式文件`);
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      uploadFile(formData).then(res => {
        const data = res.data[0];
        this.$http({
          type: "POST",
          url: "/buz/organizationFile/add",
          data: {
            orgId: this.formData.id,
            name: data.fileName,
            url: data.path,
          },
          apiPermissionCode:'org_1_4',
        }).then(res => {
          this.$notice.success("文件上传成功");
          this.getFormData(this.formData.id)
        })
      });
      return false;
    },
    // 切换文件
    checkFile(item){
      this.$http({
        type: "POST",
        url: "/buz/organizationFile/edit",
        data: {
          id: item.id,
          isUsed: item.isUsed==1?0:1,
        }
      }).then(res => {
        this.$notice.success("操作成功")
        this.getFormData(this.formData.id)
      })
    },
    // 删除
    del(row){
      this.$notice.inquiry("确定删除文件？").then(()=>{
        this.$http({
          url: "/buz/organizationFile/del",
          type: "get",
          data: {
            id:row.id,
          }
        }).then(res=>{
          this.$notice.success("删除文件成功");
          this.getFormData(this.formData.id)
        })
      });
    },
    download(item){
      this.$units.downloadFile(item.url,{},'GET',item.name);
    },
  },
};
</script>
<style lang="scss" scoped>
.salesman-form-material {
  .upload-info {
    font-size: 12px;
    color: #A8ADB7;
    position: absolute;
    right: 90px;
    top: 8px;
    z-index: 10;
  }
  .dian {
    display: block;
    width: 5px;
    height: 5px;
    background: #35BF3F;
    border-radius: 50%;
    margin-right: 4px;
    &.red {
      background: #E3461F;
    }
  }
  .file-name {
    display: flex;
    align-items: center;
    justify-content: center;
    .dian {
      align-self: flex-start;
      margin-top: 6px;
      min-width: 5px;
    }
    .name {
      color: #236DFF;
      font-size: 13px;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>